<template>
  <html>

  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
    <meta name="mobile-web-app-capable" content="yes" />
    <meta name="apple-mobile-web-app-capable" content="yes" />
    <link rel="icon" type="image/png" href="favicon.png" />
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" />

    <title>Restó APP</title>
  </head>

  <body class="home-page">
    <Header :isRestoCompleto=true ></Header>
    <div class="col-lg-12 mx-auto p-3 py-md-5">
      <main>
        <div class="container" style=" display: flex;  flex-direction: row;justify-items: flex-start; justify-content: space-around;">
         

          
         
          <loading :active.sync="isLoading"
                 ></loading>

          <form v-on:submit.prevent="ingresarComensal">
            <h3 @click="toggleCampos" class="toggle-header">
              Ingresar Comensal 
              <span :class="['toggle-icon', {'rotated': camposVisible}]">▼</span>
            </h3>
            <label class="form-label" v-show="camposVisible">Los campos marcados con (*) son obligatorios</label>
            <div class="form-group mb-3" v-show="camposVisible">
              <label class="form-label">Nombre*</label><input v-model="ingresarComensalNombre" type="text" class="form-control" />
            </div>
            <div class="form-group mb-3" v-show="camposVisible">
              <label class="form-label">Apellido*</label><input v-model="ingresarComensalApellido" type="text" class="form-control" />
            </div>
            <div class="form-group mb-3" v-show="camposVisible">
              <label class="form-label">Comensales*</label>
              
              <input style="text-align: center;"
      type="number" 
      class="form-control" 
      placeholder="Introduce cantidad de comensales" 
      aria-label="Número"
      aria-describedby="basic-addon2"
      min="1" 
      v-model="ingresarComensalComensales" />
              
            </div>
            <div class="form-group mb-3" v-show="camposVisible">
              <label class="form-label">Teléfono*</label>
              
              <VuePhoneNumberInput v-model="ingresarComensalTelefono" 
                  @update="resultsTelefono = $event"
                  default-country-code="AR"
                  :translations="{
  countrySelectorLabel: 'Código de país',
  countrySelectorError: 'Elige un país',
  phoneNumberLabel: 'Número de teléfono',
  example: 'Ejemplo :'
}" >
</VuePhoneNumberInput>

            </div>
            <div class="form-group mb-3" v-show="camposVisible">
              <label class="form-label">Correo Electronico</label>
              <input v-model="ingresarComensalEmail" type="text" 
              @input="validarEmail" 
              :class="{ 'is-invalid': !esEmailValido }"
              class="form-control" />

            </div>
            <button type="submit" class="mb-3 btn btn-primary btn-lg" v-show="camposVisible">
              Agregar a lista de espera
            </button>
            
          </form> 
        </div>
        <br />
        <h3 @click="toggleListaEspera" class="toggle-header">
          Lista de espera
          <span :class="['toggle-icon', {'rotated': listaEsperaVisible}]">▼</span>
        </h3>

        <div v-show="listaEsperaVisible">
          <hr class="" />

          <button @click="cargarListaEspera" class="button-recarga" :disabled="cargandoListaEspera">
  <span v-if="cargandoListaEspera">Cargando...</span>
  <span v-else>🔄 Actualizar</span>
</button>

          <table class="table table-responsive table-striped align-middle">
            <thead>
              <tr>
                <th scope="col">Apellido</th>
                <th scope="col">Nombre</th>
                <th scope="col">Cantidad Comensales</th>
                <th scope="col">Telefono</th>
                <th scope="col">Estado</th>
                <th scope="col">Tiempo</th>
                <th scope="col">Notificar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-show="listaEspera.length == 0">
                <td colspan="11">
                  <h4 class="text-center">NO DATA</h4>
                </td>
              </tr>
              <tr v-for="(comensalEspera, index) in listaEspera" :key="index">
                <th scope="row">{{ comensalEspera.nombre }}</th>
                <th scope="row">{{ comensalEspera.apellido }}</th>
                <th scope="row">{{ comensalEspera.comensales }}</th>
                <th scope="row">{{ comensalEspera.telefono }}</th>
                <th scope="row">{{ comensalEspera.estado }}</th>
                <th scope="row">{{ comensalEspera.tiempo }}</th>
                
                <td v-if="!comensalEspera.notificado">
                  <template>
  <div>
    <a 
      :href="`https://wa.me/${comensalEspera.telefono}?text=Su mesa ya se encuentra disponible.`" 
      target="_blank" 
      class="whatsapp-icon" 
      @click="enviarAvisoComensal(comensalEspera)"
      title="Envíanos un mensaje de WhatsApp">
      <i class="fab fa-whatsapp-square fa-2x"></i>
    </a>
  </div>
</template>

<template>
  <div>
    <a 
      :href="`tel:${comensalEspera.telefono}`" 
      class="phone-icon" 
      @click="enviarAvisoComensal(comensalEspera)"
      title="Su mesa ya se encuentra disponible">
      <i class="fas fa-phone-square-alt fa-2x"></i>
    </a>
  </div>
</template>


                </td>
                <td v-if="!comensalEspera.notificado">
                  <button type="button" class="btn btn-danger mb-3" style="margin: 0 !important"
                    v-on:click="eliminarComensalEspera(comensalEspera)">
                    Eliminar
                  </button>
                </td>

                <td v-if="comensalEspera.notificado">
                  <button type="button" class="btn btn-primary mb-3" style="margin: 0 !important"
                    v-on:click="cambioEstadoComensalIngresado(comensalEspera)">
                    Ingresar
                  </button>
                </td>
                <td v-if="comensalEspera.notificado">
                  <button type="button" class="btn btn-danger mb-3" style="margin: 0 !important"
                    v-on:click="cambioEstadoComensalAusente(comensalEspera)">
                    Ausente
                  </button>
                </td>

              </tr>
            </tbody>
          </table>
        </div>
        <br />
        <h3 @click="toggleEstadoMesas" class="toggle-header">
          Estado de mesas
          <span :class="['toggle-icon', {'rotated': estadoMesasVisible}]">▼</span>
        </h3>

 


        <div v-show="estadoMesasVisible">

          
          <label class="form-label" >Agregar una nueva mesa</label>
          

          <div class="row">
            <div class="col-md-4 offset-md-4">
          <template>
  <div class="input-group mb-3">
    <div class="input-group-prepend">
      <span class="input-group-text" style="height: 100%;">Comensales</span>
  </div>
    <input style="text-align: center;"
      type="number" 
      class="form-control" 
      placeholder="Introduce cantidad de comensales" 
      aria-label="Número"
      aria-describedby="basic-addon2"
      min="1" 
      v-model="mesaSeleccionadaAgregar" />
    <div class="input-group-append">
      <button class="btn btn-outline-secondary" type="button" @click="agregarMesa()">AGREGAR</button>
    </div>
  </div>
</template>



</div>
</div>

          <hr class="" />

          <button @click="cargarListaMesasEspera" class="button-recarga" :disabled="cargandoListaEsperaMesas">
  <span v-if="cargandoListaEsperaMesas">Cargando...</span>
  <span v-else>🔄 Actualizar</span>
</button>


          <table class="table table-responsive table-striped align-middle">
            <thead>
              <tr>
                <th scope="col">N° de mesas</th>
                <th scope="col">Cantidad Comensales</th>
                <th scope="col">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr v-show="listaMesasEspera.length == 0">
                <td colspan="11">
                  <h4 class="text-center">NO DATA</h4>
                </td>
              </tr>
              <tr v-for="(mesa, indexMesa) in listaMesasEspera" :key="indexMesa">
                <th scope="row" style="width: 10%;">{{ mesa.numero }}</th>
                <th scope="row" style="width: 10%;">{{ mesa.cantidadComensales }}</th>
                <th scope="row" style="width: 80%;" >
                
                  <template>
  <div>
    <select class="form-select" v-model="mesa.estado" style="text-align: center;"  @change="handleChangeMesa($event, mesa)">
      <option v-for="estado in estadosMesas" :key="estado" :value="estado">
        {{ estado }}
      </option>
    </select>
  </div>
</template>
                </th>
                
              </tr>
            </tbody>
          </table>


        </div>
      </main>
      <Footer />
    </div>

    <PopUpConfirmacionHtmlEspera :show="confirmacion_eliminar_html" @close="confirmacion_eliminar_html = false" @confirmar="eliminarComensal();confirmacion_eliminar_html = false;">
  <template #body >
    <div v-html="confirmacion_eliminar_msg_html" style="white-space: pre-line;"></div>
  </template>
</PopUpConfirmacionHtmlEspera>

<PopUpConfirmacionHtmlEspera :show="confirmacion_aviso_html" @close="confirmacion_aviso_html = false" @confirmar="enviarAvisoSMS();confirmacion_aviso_html = false;">
  <template #body >
    <div v-html="confirmacion_aviso_msg_html" style="white-space: pre-line;"></div>
  </template>
</PopUpConfirmacionHtmlEspera>


<PopUpConfirmacionHtmlEspera :show="confirmacion_estado_html" @close="confirmacion_estado_html = false" @confirmar="enviarAusenteEstadoComensal();confirmacion_estado_html = false;">
  <template #body >
    <div v-html="confirmacion_estado_msg_html" style="white-space: pre-line;"></div>
  </template>
</PopUpConfirmacionHtmlEspera>

<PopUpConfirmacionHtmlEsperaIngreso :show="confirmacion_ingreso_html"
:mesas="listaMesasEspera"

@close="confirmacion_ingreso_html = false" @confirmar="enviarComensalIngresado">
  <template #body >
    <div v-html="confirmacion_ingreso_msg_html" style="white-space: pre-line;"></div>
  </template>
</PopUpConfirmacionHtmlEsperaIngreso>





    <PopUp :show="error" @close="error = false">
            <template #body>
              <p>{{ error_msg }}</p>
            </template>
          </PopUp>
  </body>

  </html>
</template>

<script>
import axios from "axios";

import "vue2-datepicker/index.css";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import PopUp from "../components/PopUp.vue";

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import Loading from 'vue-loading-overlay';
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import 'vue-loading-overlay/dist/vue-loading.css';
import PopUpConfirmacionHtmlEspera from "../components/PopUpConfirmacionHtmlEspera.vue";
import PopUpConfirmacionHtmlEsperaIngreso from "../components/PopUpConfirmacionHtmlEsperaIngreso.vue";

export default {
  name: "Reservas",
  components: { Header, Footer,PopUp,VuePhoneNumberInput,Loading,PopUpConfirmacionHtmlEspera,PopUpConfirmacionHtmlEsperaIngreso},
  data: function () {
    return {
      confirmacion_eliminar_msg_html:"",
      confirmacion_eliminar_html:false,
      confirmacion_msg_html:"",
      confirmacion_aviso_html:false,
      confirmacion_aviso_msg_html:"",
      confirmacion_estado_msg_html:"",
      confirmacion_estado_html:false,
      confirmacion_ingreso_html:false,
      confirmacion_ingreso_msg_html:"",
      isLoading:false,
      mesaSeleccionadaAgregar:1,
      cargandoListaEspera: false,
      cargandoListaEsperaMesas: false,
      comensalSeleccionado:null,
      email: "",
      telefono: "",
      error: false,
      error_msg: "",
      success: false,
      success_msg: "",
      camposVisible: false,
      nombre: "",
      apellido: "",
      listaEsperaVisible: false,
      estadoMesasVisible: false,
      ingresarComensalNombre:"",
      ingresarComensalApellido:"",
      ingresarComensalComensales:1,
      ingresarComensalTelefono:"",
      ingresarComensalEmail:"",
      listaEspera:[],      
      listaMesasEspera:[],      
      estadosMesas:[],
      selectedEstadoMesa: null,
      resultsTelefono: null,
      intervalId: null,
      esEmailValido:true,
    };
  },
  mounted() {
    // Configura un intervalo para ejecutar una función cada 1 minuto (60000 milisegundos)
    this.intervalId = setInterval(this.refrescarTodo, 60000);
  },
  beforeDestroy() {
    // Limpia el intervalo cuando el componente se destruye para evitar errores y fugas de memoria
    clearInterval(this.intervalId);
  },
  methods: {
    refrescarTodo(){
      this.cargarListaEspera();
      this.cargarListaMesasEspera();
    },
    handleChangeMesa(event, mesa) {
      const selectedEstado = event.target.value;
      this.isLoading=true;
      axios.post("/espera/cambio-estado-mesa",{mesaId:mesa.id,estado:selectedEstado}).then((data) => {
        this.isLoading=false;
      if (data.status == 200) {
       this.$toast("Se cambio estado de mesa "+mesa.numero+" a "+selectedEstado+"!");
       this.cargarListaMesasEspera();
      } else {
        this.isLoading=false;
        this.error = true;
        this.error_msg =
          "No se ha podido cambiar estado. Vuelva a intentar mas tarde";
      }
    });

      // Aquí puedes agregar lógica adicional a ejecutar cuando se selecciona un nuevo estado.
    },
    convertDataObjectUrl(data) {
      return Object.keys(data)
        .map(function (k) {
          return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
          
        })
        .join("&");
    },
    formatoFecha(inputDate) {
      if(inputDate != null){
        var from = inputDate.split("-")
      return new Date(from[2], from[1] - 1, from[0]).getTime()
      }
    },
    toggleCampos() {
      this.camposVisible = !this.camposVisible;
    },
    toggleListaEspera() {
      this.listaEsperaVisible = !this.listaEsperaVisible;
    },
    toggleEstadoMesas() {
      this.estadoMesasVisible = !this.estadoMesasVisible;
    },
    limpiarFormIngresarComensal(){

      this.ingresarComensalNombre="";
      this.ingresarComensalApellido="";
      this.ingresarComensalComensales="";
      this.ingresarComensalTelefono="";
      this.ingresarComensalEmail="";
      this.esEmailValido=true;
      
    },
    enviarComensalIngresado(mesa){
      this.confirmacion_ingreso_html = false;

      this.isLoading=true;
      axios.post("/espera/cambio-estado-comensal",{
        mesaId:mesa.id,
        id:this.comensalSeleccionado,estado:"INGRESADO"}).then((data) => {
        this.isLoading=false;
      if (data.status == 200) {
       this.$toast("Se ocupo la mesa  Mesa N°"+mesa.numero+" con exito");
       this.refrescarTodo();
      } else {
        this.isLoading=false;
        this.error = true;
        this.error_msg =
          "No se ha podido cambiar estado. Vuelva a intentar mas tarde";
      }
    });


      console.log(mesa);
    },
    ingresarComensal(){

      if(
      this.resultsTelefono && !this.resultsTelefono.isValid      
      ){
        this.error = true;
        this.error_msg = "Telefono invalido";
        return;
      }

      if(this.ingresarComensalNombre=="" || this.ingresarComensalApellido=="" || this.ingresarComensalComensales=="" || this.ingresarComensalTelefono==""
      ){
        this.error_msg="Complete todos los campos";
        this.error=true;
        return;
      }

      if(!this.esEmailValido){
        this.error_msg="Email invalido";
        this.error=true;
        return;
      }
      let send={
        nombre:this.ingresarComensalNombre,
        apellido:this.ingresarComensalApellido,
        comensales:this.ingresarComensalComensales,
        telefono:this.resultsTelefono.formatInternational.trim().replace(/\s+/g, ''),
        email:this.ingresarComensalEmail,
      }
    
      this.isLoading=true;
      axios.post("/espera/agregar-comensal",send).then((data) => {
       if (data.status == 202) {        
    this.isLoading=false;
        this.limpiarFormIngresarComensal();
        this.$toast("Comensal agregado con exito! Posicion en espera "+data.data.posicion);
        this.cargarListaEspera();
      } else {
    this.isLoading=false;
         this.error = true;
         this.error_msg =
           "No se ha podido actualizar la informacion. Vuelva a intentar mas tarde";
       }
     });
    },
    cargarListaEspera(){
      this.cargandoListaEspera = true;
      axios.get("/espera/lista").then((data) => {
       if (data.status == 200) {
       this.listaEspera=data.data;
       } else {
         this.error = true;
         this.error_msg =
           "No se ha podido obtener lista de espera. Vuelva a intentar mas tarde";
       }
       this.cargandoListaEspera = false;
     });

    },

    cargarListaMesasEspera(){
      this.cargandoListaEsperaMesas=true;
      axios.get("/espera/lista-mesas").then((data) => {
       if (data.status == 200) {
       this.listaMesasEspera=data.data;
       } else {
         this.error = true;
         this.error_msg =
           "No se ha podido obtener lista de espera. Vuelva a intentar mas tarde";
       }
       
      this.cargandoListaEsperaMesas=false;
     });

    },
    eliminarComensal(){
      this.isLoading=true;
      axios.delete("/eliminar-comensal/"+this.comensalSeleccionado).then((data) => {
        this.isLoading=false;
       if (data.status == 200) {
        this.$toast("Comensal eliminado con exito!");
        this.cargarListaEspera();
       } else {
        this.isLoading=false;
         this.error = true;
         this.error_msg =
           "No se ha podido eliminar en lista de espera. Vuelva a intentar mas tarde";
       }
     });
    },
    eliminarComensalEspera(comensalEspera){
      this.comensalSeleccionado=comensalEspera.id;
      this.confirmacion_eliminar_html=true;
      this.confirmacion_eliminar_msg_html=`
      <h5>¿Desea eliminar al comensal ${comensalEspera.nombre} ${comensalEspera.apellido} de la lista?</h5>
      <b>Nota:</b>El comensal sera eliminado de la lista de espera</p>
      `
    },
 
    cambioEstadoComensalIngresado(comensalEspera){

      if(this.mesasFiltradas<1){
        this.error = true;
         this.error_msg =
           "No hay mesas libres para ingresar comensal";
        return ;
      }

      this.comensalSeleccionado=comensalEspera.id;
      this.confirmacion_ingreso_html=true;
      this.confirmacion_ingreso_msg_html=`
      <h5>¿Desea marcar al comensal ${comensalEspera.nombre} ${comensalEspera.apellido}?  </h5>
      `
    },
    cambioEstadoComensalAusente(comensalEspera){
      this.comensalSeleccionado=comensalEspera.id;
      this.confirmacion_estado_html=true;
      this.confirmacion_estado_msg_html=`
      <h5>¿Desea marcar al comensal ${comensalEspera.nombre} ${comensalEspera.apellido} como AUSENTE?  </h5>
      <b>Nota:</b> Al marcar como ausente, el comensal sera eliminado de la lista de espera</p>
      `
    },
    enviarAusenteEstadoComensal(){
      this.isLoading=true;
      axios.post("/espera/cambio-estado-comensal",{id:this.comensalSeleccionado,estado:"AUSENTE"}).then((data) => {
        this.isLoading=false;
      if (data.status == 200) {
       this.$toast("Cambio realizado con exito!");
       this.cargarListaEspera();
      } else {
        this.isLoading=false;
        this.error = true;
        this.error_msg =
          "No se ha podido cambiar estado. Vuelva a intentar mas tarde";
      }
    });
    },

    agregarMesa(){
      this.isLoading=true;
      axios.post("/espera/agregar-mesa",{comensalesMesa:this.mesaSeleccionadaAgregar}).then((data) => {
        this.isLoading=false;
      if (data.status == 200) {
        let text=this.mesaSeleccionadaAgregar>1?" comensales":" comensal";
       this.$toast("Mesa de "+this.mesaSeleccionadaAgregar+text+" agregada con exito!");
       this.cargarListaMesasEspera();
       this.cargarListaEspera();
      } else {
        this.isLoading=false;
        this.error = true;
        this.error_msg =
          "No se ha podido agregar. Vuelva a intentar mas tarde";
      }
    });
      
    },
    enviarAvisoSMS(){
      this.isLoading=true;
      axios.post("/espera/aviso-comensal-espera",{id:this.comensalSeleccionado}).then((data) => {
        this.isLoading=false;
      if (data.status == 200) {
       this.$toast("Comensal notificado con exito!");
       this.cargarListaEspera();
      } else {
        this.isLoading=false;
        this.error = true;
        this.error_msg =
          "No se ha podido notificar. Vuelva a intentar mas tarde";
      }
    });
    },


    
    enviarAvisoComensal(comensalEspera){
      this.comensalSeleccionado=comensalEspera.id;
      this.confirmacion_aviso_html=true;
      this.confirmacion_aviso_msg_html=`
      <h5>¿Se ha informado al comensal ${comensalEspera.nombre} ${comensalEspera.apellido}</h5>
      <b>Nota:</b> Es necesario saber si el comensal fue notificado
      `
   },
   obtenerEstadosMesas(){
    
    axios.get("/espera/estado-mesas").then((data) => {
       if (data.status == 200) {
       this.estadosMesas=data.data;
       } else {
         this.error = true;
         this.error_msg =
           "No se ha podido obtener lista de estados. Vuelva a intentar mas tarde";
       }
     });
   },
   validarEmail() {
    if(this.ingresarComensalEmail==""){
      this.esEmailValido=true;
      return ;
    }
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    this.esEmailValido = regex.test(this.ingresarComensalEmail);
  }


  },
  computed: {
  mesasFiltradas() {
    return this.listaMesasEspera.filter(mesa => mesa.estado !== 'OCUPADA');
  }
},
  beforeMount() {
    this.obtenerEstadosMesas();
    this.cargarListaEspera();
    this.cargarListaMesasEspera();
   
  },
  
};

</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

:host {
  --main-color: #0047b3;
  --second-color: #0198f3;
  --grey-color: #f5f8fa;
  --border-radius-1: 9px;
  --border-radius-2: 6px;
}

body {
  font-family: "Inter", sans-serif;
  color: #083744;
  font-size: 14px;
  height: 100%;
}
.mx-datepicker-range {
    width: 150px !important
}
.form-label {
    display: inline-block;
    min-width: 90px;
}

.toggle-header {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toggle-icon {
  transition: transform 0.3s ease;
}

.rotated {
  transform: rotateZ(180deg);
}

.input-group > .custom-select {
    flex-grow: 1;
}

.whatsapp-icon {
  color: #25D366; /* Color oficial de WhatsApp */
}


.button-recarga    {
  background-color: #4CAF50; /* Verde */
  border: none;
  color: white;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 12px;
}

.button-recarga  :hover {
  background-color: #45a049;
}


</style>
